import { lazy } from 'react';

const Chat = lazy(() => import('./components/Chat'));
const Import = lazy(() => import('./components/Import'));
const StudyChat = lazy(() => import('./components/StudyChat'));
const ImportQ = lazy(() => import('./components/ImportQ'));
const ImportF = lazy(() => import('./components/ImportF'));
const SectionF = lazy(() => import('./components/SectionF'));
const SectionQ = lazy(() => import('./components/SectionQ'));
const Question = lazy(() => import('./components/Questions'));
const QuestionB = lazy(() => import('./components/session/QuestionB'));
const FlashCardsB = lazy(() => import('./components/session/FlashCardsB'));
const FlashCardsSession = lazy(() => import('./components/session/FlashCardsSession'));
const NewChatApp = lazy(() => import('./components/NewChatApp'));
const NewChatFlashcards = lazy(() => import('./components/NewChatFlashcards'));
const NewChatHardFlashcards = lazy(() => import('./components/NewChatHardFlashcards'));
const NewChatQuestions = lazy(() => import('./components/NewChatQuestions'));
const NewChatHome = lazy(() => import('./components/NewChatHome'));
const NewVideoChatApp = lazy(() => import('./components/NewVideoChatApp'));
const Tools = lazy(() => import('../../components/home/Tools'));

export const aiChatPublicRoutes = [
  { path: '/new-chat', element: <NewChatApp /> },
  { path: '/new-chat/flashcards', element: <NewChatFlashcards /> },
  { path: '/new-chat/hard-flashcards', element: <NewChatHardFlashcards /> },
  { path: '/new-chat/questions', element: <NewChatQuestions /> },
  { path: '/home/new-chat', element: <NewChatHome /> },
  { path: '/new-chat/video', element: <NewVideoChatApp /> },
];

export const aiChatProtectedRoutes = [
  { path: '/home/tools/chat-ai', element: <Chat /> },
  { path: '/home/tools', element: <Tools /> },
  { path: '/home/tools/study-session', element: <Import /> },
  { path: '/home/tools/study-session/sections/study-chat', element: <StudyChat /> },
  { path: '/home/tools/generate-question', element: <ImportQ /> },
  { path: '/home/tools/generate-card', element: <ImportF /> },
  { path: '/home/tools/generate-card/sections', element: <SectionF /> },
  { path: '/home/tools/generate-question/sections', element: <SectionQ /> },
  { path: '/home/tools/generate-question/sections/questions', element: <Question /> },
  { path: '/home/tools/generate-question/sections/questions/create', element: <QuestionB /> },
  { path: '/home/tools/generate-card/sections/flashcards/create', element: <FlashCardsB /> },
  { path: '/home/tools/generate-card/sections/flashcards/review', element: <FlashCardsSession /> },
];
